import Vue from 'vue';
import creditNoteProductTransformer from '../../transformers/creditNoteProduct';
import all from './all';

const success = (data, id, resolve) => {
  all(id);
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (id, creditNoteProducts) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post(`/credit_notes/${id}/products/bulk`, { items: creditNoteProductTransformer.sendCollection(creditNoteProducts) })
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/creditNoteProduct/bulkStore.js